import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function hexToRgb(hex: string): [number, number, number] {
    // Remove # if present
    const cleanHex = hex.replace('#', '');

    // Parse RGB values
    const r = parseInt(cleanHex.substring(0, 2), 16) / 255;
    const g = parseInt(cleanHex.substring(2, 4), 16) / 255;
    const b = parseInt(cleanHex.substring(4, 6), 16) / 255;

    return [r, g, b];
}

export function initCopyToClipboard() {
    const copyButtons = document.querySelectorAll('.copy-to-clipboard');

    copyButtons.forEach((button) => {
        button.addEventListener('click', async () => {
            const textToCopy = button.getAttribute('data-clipboard-text');
            const errorMessage =
                button.getAttribute('data-clipboard-error') ||
                'Kein Text zum Kopieren gefunden.';
            const successMessage =
                button.getAttribute('data-clipboard-success') ||
                'Link wurde in die Zwischenablage kopiert!';
            const copyErrorMessage =
                button.getAttribute('data-clipboard-copy-error') ||
                'Fehler beim Kopieren in die Zwischenablage.';

            if (!textToCopy) {
                if (window.showToast) {
                    window.showToast(errorMessage, 'error');
                }
                return;
            }

            try {
                await navigator.clipboard.writeText(textToCopy);
                if (window.showToast) {
                    window.showToast(successMessage, 'success');
                }
            } catch (error) {
                if (window.showToast) {
                    window.showToast(copyErrorMessage, 'error');
                }
                console.error('Clipboard error:', error);
            }
        });
    });
}

export function initWebShare() {
    const shareButtons = document.querySelectorAll('.share-button');

    shareButtons.forEach((button) => {
        button.addEventListener('click', async () => {
            // Prüfe ob Web Share API verfügbar ist
            if (!navigator.share) {
                return;
            }

            const shareData = {
                title: document.title,
                text: document.title,
                url: window.location.href
            };

            try {
                await navigator.share(shareData);
            } catch (error) {
                // User hat Share abgebrochen oder Fehler aufgetreten
                console.error('Share error:', error);
            }
        });
    });
}
